/**************************************************
 * Nombre:       Tarjeta_Habitaciones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {CheckCircle} from "@mui/icons-material";
import hab_lista from "../../Recursos/hab_lista.svg";
import hab_reservada from "../../Recursos/hab_reservada.svg";
import hab_mantenimiento from "../../Recursos/hab_mantenimiento.svg";
import {ESTADOSHABITACIONES} from "../../Constantes";

const Tarjeta_Habitaciones = ({seleccionada, setSeleccionada, it, habOcupadas}) => {

    const obtenerImgHabitacion = (estado) => {

        if (estaOcupada()) {
            return hab_reservada
        }

        switch (estado) {
            case ESTADOSHABITACIONES[0]:
                return hab_lista
            case ESTADOSHABITACIONES[1]:
                return hab_mantenimiento

        }
    }

    const estaOcupada = () => {
        return habOcupadas.findIndex((e) => e === it.numero) > -1
    }

    return (
        <Grid
            onClick={() => estaOcupada() || it.estado === ESTADOSHABITACIONES[1] ?
                alert('habitacion no disponible')
                :
                setSeleccionada(it)
            }
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={12}
            sx={{cursor: 'pointer'}}
        >


            <Grid container size={12}
                  justifyContent={'flex-start'}>
                <Typography
                    sx={{
                        fontSize: 12,
                        fontWeight: 600,
                    }}>{`${it.numero}`}</Typography>
            </Grid>

            <Grid container size={12}
                  justifyContent={'flex-start'} sx={{mt: -0.5}}>
                <Typography
                    sx={{
                        fontSize: 10,
                        fontWeight: 600,
                    }}>{`${it.tipo}`}</Typography>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 0}}>
                <img src={obtenerImgHabitacion(it.estado)} width={'100%'} height={'auto'}/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  justifyContent={'center'} sx={{mt: -7}}>
                {seleccionada.id === it.id &&
                    <CheckCircle sx={{
                        fill: '#fff',
                        height: 40,
                        width: 40
                    }}/>
                }
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Habitaciones